
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M6.552 16c0-1.016.168-1.99.47-2.904L1.749 9.07A15.637 15.637 0 00.142 16c0 2.491.579 4.84 1.605 6.926l5.27-4.035A9.256 9.256 0 016.552 16","fill":"#FBBC05"}}),_c('path',{attrs:{"d":"M15.81 6.756c2.207 0 4.2.782 5.767 2.062l4.558-4.551C23.358 1.849 19.797.356 15.809.356A15.62 15.62 0 001.75 9.07l5.273 4.026a9.233 9.233 0 018.787-6.34","fill":"#EA4335"}}),_c('path',{attrs:{"d":"M15.81 25.244a9.233 9.233 0 01-8.788-6.34L1.749 22.93a15.62 15.62 0 0014.06 8.714c3.821 0 7.47-1.356 10.208-3.899l-5.005-3.869c-1.412.89-3.19 1.368-5.203 1.368","fill":"#34A853"}}),_c('path',{attrs:{"d":"M30.764 16c0-.924-.143-1.92-.356-2.844H15.809V19.2h8.403c-.42 2.06-1.564 3.645-3.2 4.676l5.005 3.87c2.876-2.67 4.747-6.647 4.747-11.746","fill":"#4285F4"}})])])
          )
        }
      }
    